import React from "react";
import "./Loader.css";
import Chunk1 from "../../../assets/icons/loader_chunk_1.svg";
import Chunk2 from "../../../assets/icons/loader_chunk_2.svg";

interface LoaderProps {
  text?: string;
  subText?: string;
  type?: "default" | "avatar-oriented"
}

const Loader: React.FC<LoaderProps> = ({ text, subText, type = "default" }) => {
  return (
    <div className="app-loader">
      {type === "default" && <div className="loader-text">{text}</div>}
      <div className={`loader-container ${type === "avatar-oriented" && "avatar-oriented-loader-container"}`}>
        <div className="loader-chunk-1">
          <img src={Chunk1} alt="Loader chunk 1" />
        </div>
        <div className="loader-chunk-2">
          <img src={Chunk2} alt="Loader chunk 2" />
        </div>
      </div>
      {
        type === "avatar-oriented" && (<>
          <div className="avatar-oriented-loader-text">{text}</div>
          <div className="avatar-oriented-loader-subtext">{subText}</div>
        </>)
      }
    </div>
  );
};

export default Loader;
